import styled from 'styled-components'
import { BREAK_POINT_SM, BREAK_POINT_LG } from '@CSSVars/variables'
import { OUTLINE_COLOR, TEXT_GREY } from '@CSSVars/colors'


export const _ListingSpecUl = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  span {
    line-height: 22px;
    font-size: 12px;
  }
  div {
    display: flex;
  }
`

export const _BeforeSeparator = styled.span.attrs({
  className: 'spanBeforeSeparator',
})`
  position: relative;

  ${({ bold }) => (bold && 'font-weight: 600')};
  &.spanBeforeSeparator {
    padding-left: 12px;
    &:before {
      content: " ";
      position: absolute;
      height: 10px;
      width: 1px;
      left: 5px;
      top: 50%;
      background-color: ${OUTLINE_COLOR};
      transform: translateY(-50%);
    }
  }


`

export const _InfoContainer = styled.div`
  position: relative;
  white-space: nowrap;
  width: 100%;
  span {
    position: relative;
    line-height: 22px;
    font-size: 12px;
  }
  ${({ isBc }) => (isBc && `
    &:last-child{
    display: flex;
    flex-direction: column;
  }
  `)};
`
export const _MaintFee = styled(_BeforeSeparator)`
  width: 100%;
  font-size: 12px;
  line-height: 22px;
  color: ${TEXT_GREY};
  @media screen and (min-width: ${BREAK_POINT_SM}) {
    &:before {
      content: " ";
      position: absolute;
      height: 10px;
      width: 1px;
      left: 5px;
      top: 50%;
      background-color: ${OUTLINE_COLOR};
      transform: translateY(-50%);

    }
  }
`

export const _BrokerageInfo = styled.div`
  width: 100%;
  @media screen and (min-width: ${BREAK_POINT_LG}) {
    width: 254px;
  }
  div {
    display: block;
    font-size: 10px;
    line-height: 14px;
    color: ${TEXT_GREY};
  }
`
export const _Separator = styled.div`
  color: ${OUTLINE_COLOR};
  padding: 0 4px;
`
